<template>
  <div class="column-float">
    <span class="title" v-if="row.numeroGuiaReembolso">{{column.title}}</span>
    <span class="preco">{{price}}</span>
  </div>
</template>

<script>
export default {
  name: 'MoedaItem',
  props: ['column', 'row'],
  computed: {
    price () {
      let price = this.row[this.column.field].toFixed(2)
      price = price.toString()
      price = price.replace('.', ',')
      return price
    }
  }
}
</script>
<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Open+Sans&display=swap');
.column-float {
  float: right;
}
.preco {
  font-size: 14px;
  font-family: "Open Sans", SansSerif;
  color: #333333;
  font-weight: 400;
}
.title {
  display: block;
}
@media print {
  .column-float {
    float: right;
    position: fixed;
    right: 70px;
  }
}
</style>
